module.exports = __webpack_public_path__ + "static/elite-fitness-logo-52e9e201d13224b1be6b19a15c7f002e.jpg";